import { useEffect, useState } from 'react';

/**
 * Debounce hook
 * Delays updating a value until after a specified delay has passed since the last change
 * Used for rating inputs to prevent excessive API calls
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
